import ExhaustiveCaseError from './ExhaustiveCaseError';
import { getPrecedence } from './operators';
import { CoreTokenTypes } from './tokens';
import isNil from './util/isNill';
function doMath(val1, operator, val2) {
    switch (operator) {
        case '*':
            return val1 * val2;
        case '+':
            return val1 + val2;
        case '-':
            return val1 - val2;
        case '/':
            return val1 / val2;
    }
}
function calculateUnaryOperation(operator, val) {
    switch (operator) {
        case '*':
        case '/':
            throw new Error("Operator '" + operator + "' may not be used as a unary operator");
        case '+':
            return +val;
        case '-':
            return -val;
    }
}
var isOperator = function (stackItem) {
    return typeof stackItem === 'string';
};
var isValue = function (stackItem) {
    return typeof stackItem === 'number';
};
function calculateFinalResult(tokens, values) {
    var i = 0;
    function tallyRolls() {
        var stack = [];
        var peekTop = function () { return stack[stack.length - 1]; };
        var popValue = function () {
            var top = stack.pop();
            if (isNil(top))
                throw new Error('Expected dice roll or constant but got nothing');
            if (isOperator(top))
                throw new Error('Expected dice roll or constant but got operator');
            return top;
        };
        var popOperator = function () {
            var top = stack.pop();
            if (isNil(top))
                throw new Error('Expected operator but got nothing');
            if (isValue(top))
                throw new Error('Expected operator but got dice roll or constant');
            return top;
        };
        var popStack = function () {
            var total = popValue();
            while (stack.length) {
                var operator = popOperator();
                while (isOperator(peekTop())) {
                    total = calculateUnaryOperation(operator, total);
                    operator = popOperator();
                }
                if (isNil(peekTop())) {
                    total = calculateUnaryOperation(operator, total);
                }
                else {
                    var value = popValue();
                    total = doMath(value, operator, total);
                }
            }
            stack.push(total);
        };
        var popStackIfNecessary = function (top) {
            var lookAhead = tokens[i + 1];
            if (top &&
                isOperator(top) &&
                (isNil(lookAhead) ||
                    lookAhead.type !== CoreTokenTypes.Operator ||
                    getPrecedence(top) <= getPrecedence(lookAhead.operator))) {
                popStack();
            }
        };
        var getRollValue = function () {
            var value = values[i];
            if (isNil(value))
                throw new Error("Roll values do not match provided tokens. Expected value but got none at position " + i);
            return value;
        };
        for (; i < tokens.length; i++) {
            var token = tokens[i];
            switch (token.type) {
                case CoreTokenTypes.DiceRoll: {
                    var top_1 = peekTop();
                    stack.push(getRollValue());
                    popStackIfNecessary(top_1);
                    break;
                }
                case CoreTokenTypes.OpenParen: {
                    i++;
                    var top_2 = peekTop();
                    stack.push(tallyRolls());
                    popStackIfNecessary(top_2);
                    break;
                }
                case CoreTokenTypes.CloseParen:
                    if (stack.length > 1)
                        throw new Error("Unexpected leftover tokens at position " + i);
                    return popValue();
                case CoreTokenTypes.Operator:
                    stack.push(token.operator);
                    break;
                default:
                    throw new ExhaustiveCaseError('Unknown token type', token);
            }
        }
        if (stack.length)
            popStack();
        return popValue();
    }
    return tallyRolls();
}
export default calculateFinalResult;
